import React, { Suspense, useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { RoutersList } from './RoutersList';
import DycRouteSettingConfig from './DycRouteSettingConfig';
import Loader from '../common/loader/Loader';
import MaintenancePage from '../layout/Maintance';
import { useDispatch, useSelector } from 'react-redux';
import { resetMaintenanceModeIfExpired } from '@/store/slices/shoppingAssistanceSlice';
import MaintenanceModal from '@/components/ai-shopping/Modal/MaintenanceModal';



const ResolveRoutes = ({ isUnderMaintenance,isInMaintenanceMode,resetTimestamp }) => {

    if (isUnderMaintenance) {
        // Render Maintenance Page if under maintenance
        return <MaintenancePage />;
    }

    if(isInMaintenanceMode){
        return <MaintenanceModal show={isInMaintenanceMode}  resetTimestamp={resetTimestamp}/>
    }

    if (RoutersList) {
        return RoutersList.map((routes, i) => {
            return (
                <DycRouteSettingConfig
                    key={i}
                    routeLayout={routes.RouteLayout}
                    protectRoute={routes.ProtectRoute}
                    routeList={routes.RouteList}
                    index={i}
                />
            );
        });
    }
};

const AppRoute = (props) => {
    const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);
    const isInMaintenanceMode = useSelector(state => state.aiShoppingInfo.isInMaintenanceMode);
    const resetTimestamp = useSelector(state => state.aiShoppingInfo.maintenanceResetTimestamp);
    const dispatch = useDispatch();
    
    useEffect(() => {
       // Define the maintenance start and end times in CST
            const maintenanceStartCST = new Date("2025-01-17T23:05:00+05:30"); // 10:00 PM IST, January 24th, 2025
            const maintenanceEndCST = new Date("2025-01-17T23:10:00+05:30"); // 11:00 AM IST, January 25th, 2025
            // Convert CST times to UTC (ISO strings)
            const maintenanceStartUTC = maintenanceStartCST.toISOString();
            const maintenanceEndUTC = maintenanceEndCST.toISOString();

            // Get the current time in UTC
            const currentTimeUTC = new Date().toISOString();

            // Function to check if current time is within maintenance window
            function isMaintenanceModeActive(currentTime, startTime, endTime) {
                if (currentTime >= startTime && currentTime <= endTime) {
                    return true;  // Maintenance mode is active
                }
                return false;  // Maintenance mode is not active
            }

            // Check if maintenance mode is active
            const isActive = isMaintenanceModeActive(currentTimeUTC, maintenanceStartUTC, maintenanceEndUTC);
            if (isActive) {
               setIsUnderMaintenance(isActive);
            }
          // Periodically check to update the maintenance status          
        // setIsUnderMaintenance(true);
    }, []); // Runs only once when the component mounts


     // ✅ Rehydrate maintenance from localStorage on page load
  useEffect(() => {
    const storedTimestamp = localStorage.getItem("maintenanceResetTimestamp");
    const storedMessage = localStorage.getItem("maintenanceMessage");

    if (storedTimestamp && Date.now() < Number(storedTimestamp)) {
      dispatch({
        type: 'aiShoppingInfo/setMaintenanceModeFromStorage',
        payload: {
          isEnabled: true,
          resetTime: Number(storedTimestamp),
          message: storedMessage,
        }
      });
    }
  }, [dispatch]);

  // ✅ Cross-tab sync
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "maintenanceResetTimestamp") {
        const resetTimestamp = localStorage.getItem("maintenanceResetTimestamp");
        const message = localStorage.getItem("maintenanceMessage");

        if (resetTimestamp && Date.now() < Number(resetTimestamp)) {
          dispatch({
            type: "aiShoppingInfo/setMaintenanceModeFromStorage",
            payload: {
              isEnabled: true,
              resetTime: Number(resetTimestamp),
              message,
            }
          });
        } else {
          dispatch({ type: "aiShoppingInfo/resetMaintenanceModeIfExpired" });
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [dispatch]);

  // ✅ Timer to auto-expire
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(resetMaintenanceModeIfExpired());
    }, 10000);
    return () => clearInterval(interval);
  }, [dispatch, isInMaintenanceMode, resetTimestamp]);
      

    return (
        <React.Fragment>
            <Loader isOpen={false} />
            <Suspense fallback={<h1><Loader isOpen={true} /></h1>}>
                <BrowserRouter>
                    {/* Pass maintenance state to ResolveRoutes */}
                    <ResolveRoutes isInMaintenanceMode={isInMaintenanceMode} resetTimestamp={resetTimestamp}  isUnderMaintenance={isUnderMaintenance} />
                </BrowserRouter>
            </Suspense>
        </React.Fragment>
    );
};

export default AppRoute;
